
import Axios from "axios";

import {
  SET_PRICE_CALCULATION_DETAILS_LIST,
  UNSET_PRICE_CALCULATION_DETAILS_LIST,
} from "@/store/mutation-types";

import {
  getPriceCalculations,
  saveUpdatePriceCalculation,
  getPriceCalculationById,
} from "@/store/api";

const state = {
  priceCalculationList: [],
  editingPriceCalculation: null,
  viewingPriceCalculation: null,
};

const getters = {
  getPriceCalculationList(state) {
    return state.priceCalculationList || [];
  },

  getEditingPriceCalculation(state) {
    return state.editingPriceCalculation;
  },

  getViewingPriceCalculation(state) {
    return state.viewingPriceCalculation;
  },
};

const mutations = {
  [SET_PRICE_CALCULATION_DETAILS_LIST](state, data) {
    state.priceCalculationList = data;
  },

  [UNSET_PRICE_CALCULATION_DETAILS_LIST](state) {
    state.priceCalculationList = [];
  },

  setEditingPriceCalculation(state, data) {
    state.editingPriceCalculation = data;
  },

  setViewingPriceCalculation(state, data) {
    state.viewingPriceCalculation = data;
  },
};

const actions = {

  saveUpdatePriceCalculation({ commit }, data) {

    commit("SET_LOADING", {
      color: "primary"
    });

    return new Promise((resolve, reject) => {

      Axios.post(saveUpdatePriceCalculation, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getPriceCalculations({ commit }, data) {

    return new Promise((resolve, reject) => {

      Axios.post(getPriceCalculations, data)
        .then((response) => {

          commit(
            SET_PRICE_CALCULATION_DETAILS_LIST,
            response.data.data
          );

          resolve(response);
        })
        .catch((error) => {

          commit(UNSET_PRICE_CALCULATION_DETAILS_LIST);

          reject(error);
        });
    });
  },

  getPriceCalculationById({ commit }, id) {

    const url = `${getPriceCalculationById}/${id}`;

    commit("SET_LOADING", {
      color: "primary"
    });

    return new Promise((resolve, reject) => {

      Axios.get(url)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
